import $ from "jquery";
const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

var $body = $("body");
var $headerNav = $(".header-nav");
var $headerNavButton = $(".header-nav__button");
var targetElement = $headerNav[0];

$headerNavButton.on("click", function() {
  if ($headerNav.hasClass("show")) {
    $headerNav.removeClass("show");
    enableBodyScroll(targetElement);
  } else {
    $headerNav.addClass("show");
    disableBodyScroll(targetElement);
  }
});
